<template>
    <div class="w-full">
        <div v-if="currentCategory" class="mb-6 flex flex-col gap-4">
            <!--
            <button @click="goBack" class="flex items-center gap-2 text-slate-500 hover:text-slate-800 dark:hover:text-white transition-colors w-fit">
                <x-icons name="arrow_back" class="" />
                <span class="font-medium text-sm">Tornar</span>
            </button>
            -->

            <h1 class="text-2xl font-bold text-slate-800 dark:text-white">
                {{ currentCategory.name }}
            </h1>

            <a v-if="currentCategory.link" :href="currentCategory.link" class="w-full flex items-center justify-center gap-3 rounded-xl bg-primary text-white py-4 px-6 font-bold text-lg shadow-lg shadow-primary/20 hover:bg-primary/90 transition-all">
                <span>
                    {{ transPeralbaPro.item1423 }}
                </span>
            </a>
        </div>
        
        <div v-else class="mb-6">
            <h1 class="text-2xl font-bold text-slate-800 dark:text-white">
                {{ transPeralbaPro.item1422 }}
            </h1>
        </div>

        <div class="bg-white rounded-xl border border-slate-100 overflow-hidden">
            <a v-for="category in displayedCategories" 
               :key="category.id"
               @click.prevent="handleCategoryClick(category)"
               :href="category.link"
               class="flex items-center justify-between p-2 hover:bg-slate-50 transition-colors border-b border-slate-50 dark:border-slate-800">
                
                <div class="flex items-center gap-4">
                    <div class="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-800 overflow-hidden">
                        <img v-if="category.image" :src="category.image" :alt="category.name" class="w-full h-full object-cover" />
                        <x-icons v-else name="category" class="text-primary" />
                    </div>
                    
                    <span class="font-semibold">
                        {{ category.name }}
                    </span>
                </div>
                
                <x-icons name="chevron_right" class="text-slate-300 mr-2" />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategoriesApp',
    props: {
        transPeralbaPro: {
            type: [Boolean, String, Number, Object, Array],
            required: false
        },
        initialCategories: {
            type: [Array, String],
            required: true
        }
    },
    data() {
        return {
            categories: [],
            history: [] // Guarda l'historial per poder fer el "Tornar enrere"
        }
    },
    mounted() {
        // Escoltar el botó enrere de la capçalera
        window.addEventListener('categories-go-back', this.goBack);
    },
    beforeUnmount() {
        window.removeEventListener('categories-go-back', this.goBack);
    },
    computed: {
        currentCategory() {
            // Retorna l'última categoria que hem visitat (la que tenim oberta)
            return this.history.length > 0 ? this.history[this.history.length - 1] : null;
        },
        displayedCategories() {
            // Si estem dins una categoria, mostrem els seus fills. Si no, mostrem les arrel.
            return this.currentCategory ? this.currentCategory.children : this.categories;
        }
    },
    created() {
        // Parsejar les dades que ens arriben de Blade
        if (typeof this.initialCategories === 'string') {
            this.categories = JSON.parse(this.initialCategories);
        } else {
            this.categories = this.initialCategories;
        }
    },
    methods: {
        handleCategoryClick(category) {
            // Si la categoria té subcategories, hi entrem
            if (category.children && category.children.length > 0) {
                this.history.push(category);
                window.dispatchEvent(new CustomEvent('categories-navigation', { 
                    detail: { canGoBack: true, categoryName: category.name } 
                }));
            } else {
                // Si no té subcategories, l'enllaç ens porta directament als productes
                window.location.href = category.link;
            }
        },
        goBack() {
            // Eliminem l'última categoria de l'historial per tornar amunt
            this.history.pop();
            window.dispatchEvent(new CustomEvent('categories-navigation', { 
                detail: { 
                    canGoBack: this.history.length > 0,
                    categoryName: this.history.length > 0 ? this.history[this.history.length - 1].name : null
                } 
            }));
        }
    }
}
</script>